import {
  watchLoadLeadSurvey,
  watchLoadLeadSurveyCompleted,
  watchSubmitLeadSurvey,
  watchSurveyAnswer
} from '@portalterreno/nextjs-client/portalterreno/redux/sagas/leadSurvey';
// eslint-disable-next-line import-length/import-length
import { watchUserInformation } from '@portalterreno/nextjs-client/redux/sagas/user';
import { all, AllEffect } from 'redux-saga/effects';

import watchCancelMultipleLeads from './multipleLeads/watchCancelMultipleLeads';
import watchLoadMultipleLeadsModal from './multipleLeads/watchLoadMultipleLeadsModal';
import watchSendMultipleLeads from './multipleLeads/watchSendMultipleLeads';
import watchContactForm from './watchContactForm';
import watchLeadMagnetForm from './watchLeadMagnetForm';
import watchSubmitReportForm from './watchSubmitReportForm';

export default function* rootSaga(): Generator<
  AllEffect<unknown>,
  void,
  unknown
> {
  yield all([
    watchCancelMultipleLeads(),
    watchContactForm(),
    watchLeadMagnetForm(),
    watchLoadLeadSurvey(),
    watchLoadLeadSurveyCompleted(),
    watchLoadMultipleLeadsModal(),
    watchSendMultipleLeads(),
    watchSubmitLeadSurvey(),
    watchSubmitReportForm(),
    watchSurveyAnswer(),
    watchUserInformation()
  ]);
}
